import React from 'react';
import { Modal } from 'react-bootstrap';

import api from '../../apiClient/v1';
import TablaResumenMensual from "./TablaResumenMensual.jsx"

class ResumenMensual extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            data: {
                auditorias: {
                    totales: [],
                    regiones: []
                },
                sensores: {
                    totales: [],
                    regiones: []
                }
            },
            pestaña: "auditorias"
        }
        this.show = () => this.setState({ visible: true })
        this.hide = () => this.setState({ visible: false })
    }

    componentDidMount() {
        api.auditoria.getResumenEstadoMesActual()
            .then((response) => {
                console.log(response)
                this.setState({
                    data: {
                        auditorias: {
                            totales: response.auditorias.totales,
                            regiones: response.auditorias.regiones
                        },
                        sensores: {
                            totales: response.sensores.totales,
                            regiones: response.sensores.regiones
                        }
                    }
                })
            })
            .catch(error => {
                console.log(error)
            })
    }
    cambiarPestaña() {
        this.setState({
            pestaña: this.state.pestaña == "auditorias" ? "sensores" : "auditorias"
        })
    }

    render() {
        return (
            <div>
                <button className='btn btn-warning btn-xs' onClick={this.show}>Resumen Estado Mensual</button>
                <Modal show={this.state.visible} onHide={this.hide} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{display: "flex", gap: "12px", alignItems: "center"}}>
                                <span>Estado general de auditorías</span>
                                <button onClick={this.cambiarPestaña.bind(this)} style={{backgroundColor: "rgb(59 130 246)", color: "white", textTransform: "capitalize", padding:"4px 12px", borderRadius: "8px", border: "none"}}>
                                    Ver {this.state.pestaña == "auditorias" ? "Resumen Sensores" : "Resumen Auditorias"}
                                </button>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TablaResumenMensual data={this.state.data[this.state.pestaña]}/>
                    </Modal.Body >
                </Modal >
            </div >
        );
    }
}

export default ResumenMensual;


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/ResumenMensual.jsx